import React, { useState, useEffect } from 'react';
import './TokenCountdown.css';

interface TokenCountdownProps {
  onExpired?: () => void;
}

const TokenCountdown: React.FC<TokenCountdownProps> = ({ onExpired }) => {
  const [timeLeft, setTimeLeft] = useState<string>('');
  const [isExpiring, setIsExpiring] = useState(false);

  useEffect(() => {
    let timerId: number | null = null;

    const scheduleNext = (ms: number) => {
      if (timerId != null) {
        window.clearTimeout(timerId);
      }
      timerId = window.setTimeout(calculateTimeLeft, ms);
    };

    const calculateTimeLeft = () => {
      // Main app persists auth token under `token`.
      const token = localStorage.getItem('token');
      if (!token) {
        setTimeLeft('Нет токена');
        setIsExpiring(false);
        scheduleNext(30000);
        return;
      }

      try {
        // Декодируем JWT токен (простое декодирование base64, без проверки подписи)
        const payloadPart = token.split('.')[1];
        if (!payloadPart) {
          setTimeLeft('Ошибка');
          setIsExpiring(false);
          scheduleNext(30000);
          return;
        }
        const payload = JSON.parse(atob(payloadPart));
        if (!payload?.exp) {
          setTimeLeft('Бессрочно');
          setIsExpiring(false);
          scheduleNext(60000);
          return;
        }

        const expirationTime = payload.exp * 1000; // exp в секундах, переводим в миллисекунды
        const currentTime = Date.now();
        const timeDiff = expirationTime - currentTime;

        if (timeDiff <= 0) {
          setTimeLeft('Истёк');
          setIsExpiring(true);
          onExpired?.();
          return;
        }

        // Если осталось меньше часа - показываем красным
        if (timeDiff < 60 * 60 * 1000) {
          setIsExpiring(true);
        } else {
          setIsExpiring(false);
        }

        // Форматируем время
        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

        if (days > 0) {
          setTimeLeft(`${days}д ${hours}ч`);
        } else if (hours > 0) {
          setTimeLeft(`${hours}ч ${minutes}м`);
        } else if (minutes > 0) {
          setTimeLeft(`${minutes}м ${seconds}с`);
        } else {
          setTimeLeft(`${seconds}с`);
        }
        // На длинных сессиях не нужно тиканье каждую секунду.
        scheduleNext(timeDiff > 60 * 60 * 1000 ? 30000 : 1000);
      } catch (error) {
        console.error('Ошибка декодирования токена:', error);
        setTimeLeft('Ошибка');
        setIsExpiring(false);
        scheduleNext(30000);
      }
    };

    calculateTimeLeft();

    return () => {
      if (timerId != null) {
        window.clearTimeout(timerId);
      }
    };
  }, [onExpired]);

  return (
    <div className={`token-countdown ${isExpiring ? 'expiring' : ''}`}>
      <span className="countdown-label">Сессия:</span>
      <i className="fas fa-clock"></i>
      <span className="countdown-text">{timeLeft}</span>
    </div>
  );
};

export default TokenCountdown;
